import { render, staticRenderFns } from "./ModalSolicitacaoCirurgiaHeader.vue?vue&type=template&id=88345fc2&scoped=true"
import script from "./ModalSolicitacaoCirurgiaHeader.vue?vue&type=script&lang=ts"
export * from "./ModalSolicitacaoCirurgiaHeader.vue?vue&type=script&lang=ts"
import style0 from "./ModalSolicitacaoCirurgiaHeader.vue?vue&type=style&index=0&id=88345fc2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88345fc2",
  null
  
)

export default component.exports